import { FC } from 'react';

import { Braces, File, Music, Sheet, Video } from 'lucide-react';

interface FileIconProps {
  contentType: string;
}

export const FileContentTypeIcon: FC<FileIconProps> = ({ contentType }) => {
  if (contentType.includes('json')) {
    return <Braces width={20} color="purple" />;
  }

  if (contentType.includes('audio')) {
    return <Music width={20} color="coral" />;
  }

  if (contentType.includes('video')) {
    return <Video width={20} color="tomato" />;
  }

  if (contentType.includes('openxmlformats')) {
    return <Sheet width={20} color="cornflowerblue" />;
  }

  return <File width={20} />;
};
